import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  shoppingCartModalSource = new Subject<any>();
  shoppingCartModal$ = this.shoppingCartModalSource.asObservable();

  constructor(private _apiService: ApiService) { }

  createCartItem(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CART}`
    return this._apiService.post(url, data)
  }

  getCartItem(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CART}/${data}`
    return this._apiService.get(url)
  }

  purchasedContent() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PURCHASED_CONTENT}`
    return this._apiService.post(url)
  }

  giftContent(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GIFT}`
    return this._apiService.post(url, data)
  }

  reGiftContent(id, data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GIFT}/${id}/${API_ENDPOINTS.API.REGIFT}`
    return this._apiService.put(url, data)
  }

  showPendingGifts() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.PENDING_GIFTS}`
    return this._apiService.get(url)
  }

  allCartItems(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CART}/${data}`
    return this._apiService.get(url)
  }

  acceptRejectGifts(item, id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GIFT}/${id}/${item}`
    return this._apiService.put(url)
  }

  allCartItemsCopy() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CART}`
    return this._apiService.get(url)
  }

  clearCart() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CART}${API_ENDPOINTS.API.CLEAR_CART}`
    return this._apiService.delete(url)
  }

  removeItemFromCart(id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CART}/${id}`
    return this._apiService.delete(url)
  }

  recentTransactionDetails() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.TOKENS}${API_ENDPOINTS.API.RECENT_PAYMENT_STATUS}`
    return this._apiService.get(url)
  }

  updateCart(params) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.UPDATE_CART_ITEMS}`
    return this._apiService.mulitipartFormPut(url, params)
  }
}
